import { getApiCurrentLanguage } from './functions';
import axios from "axios";

//https://preservemlamemoria.coib.cat/dedalo/lib/dedalo/publication/server_api/v1/docu/ui/?code=387Yg_4$3_kj2MzzA-!Bg61_X98Zs-%C3%A7&db_name=web_coib&lang=lg-cat
export const domain     = "https://dedalo.coib.cat";
const URL_SERVER        = domain+'/dedalo/lib/dedalo/publication/server_api/v1/json';
const db_name           = 'web_coib';
//const db_name           = 'web_coib_pre';
const code              = '387Yg_4$3_kj2MzzA-!Bg61_X98Zs-ç'; //web_coib
//const code              = '6_GF5$_NcÑ87_as_mvb72_mptP91_gpLa!'; //web_coib_pre
const records           = '/records';
const language          = getApiCurrentLanguage();

export async function getPageText(term_id){
    const filter = encodeURIComponent('term_id="'+term_id+'"');
    return await axios.post(
        URL_SERVER+
        "/records"+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_web"+
        "&lang=lg-"+language+
        "&sql_filter="+filter
    ).then(res => {
        return res.data.result[0] ? res.data.result[0] : null
    });
}


export async function getApartat(group){
    const grupConvert = {
        'acompanyant': 8,
        'empatitzant': 14,
        'ensenyant': 11,
        'reconfortant': 12,
        'escoltant': 9,
        'respectant': 13,
        'ajudant': 10
    };

    const params = new URLSearchParams({
        section_id: grupConvert[group],
        ar_fields: [
            "term_id",
            "term",
            "indexations",
            "indexations_related",
            "other_images",
            "other_images_resolved"
        ],
        resolve_portal: false,
        resolve_portals_custom: '{"other_images":"image"}',
        resolve_dd_relations: false
    }).toString();
    return await axios.post(
        URL_SERVER+
        records+
        "?code="+code+
        "&db_name="+db_name+
        "&table=ts_web"+
        "&"+params+
        "&lang=lg-"+language+
        "&limit=0"
    ).then(res => {
        return res.data.result[0] ? res.data.result[0] : null
    }).then(res => {
        if (res === null) {
            return null;
        }
        res.indexations = JSON.parse(res.indexations);
        return res;
    });
}

export async function getFragmentfromIndexLocator(index_locator){

    const ar_calls = [
        {
            "id":"fragment_from_index_locator",
            "options":{
                "dedalo_get":"fragment_from_index_locator",
                "index_locator": index_locator,
                "fragment_terms": true,
                "lang":"lg-"+language
            }
        },
        {
            "id":"interview",
            "options":{
                "dedalo_get":"records",
                "table":"interview",
                "section_id": JSON.parse(index_locator).section_top_id,
                "lang":"lg-"+language,
                "sql_filter":"informant is not null",
                "resolve_portals_custom":'{"informant":"informant"}'
            }
        }
        ];

        return await axios.post(
            URL_SERVER+ //  https://inm.render.es/dedalo/lib/dedalo/publication/server_api/v1/json
            "/combi"+
            "?code="+code+ //   inm3014rtAw_testimonios
            "&db_name="+db_name+ //   dedalo4_public
            "&ar_calls="+JSON.stringify(ar_calls)+
            "&lang=lg-"+language+
            "&limit=0"
        );
}
